import React, { useState } from "react";

export default function BonusFaq() {
  const [openIndex, setOpenIndex] = useState(0); // 1st open by default

  const termsList = [
    {
      id: 1,
      icon: "bx bxs-institution",
      title: "1. Bonus Structure — 30% Tradable Bonus",
      content: [
        "Clients who enroll receive a 30% tradable bonus on their account.",
        "Bonus is provided as credit — it can be used for trading but not withdrawn directly.",
        "Deposit $100 → $30 bonus credit | Deposit $1,000 → $300 bonus credit.",
      ],
    },
    {
      id: 2,
      icon: "bx bx-transfer-alt",
      title: "2. Bonus Conversion (Withdrawal Eligibility)",
      content: [
        "To convert bonus credit into withdrawable real balance, every $100 of bonus requires 2.5 standard lots of executed trading volume.",
        "Volume is calculated on closed trades only (opened positions excluded).",
        "Once the required volume is completed, the bonus converts to real balance and becomes fully withdrawable.",
      ],
    },
    {
      id: 3,
      icon: "bx bx-log-out-circle",
      title: "3. Withdrawal Before Completion",
      content: [
        "You may withdraw your original deposit at any time, even before completing the volume.",
        "However, all bonus credit will be cancelled (set to zero) immediately upon withdrawal.",
        "Any profits generated using the bonus credit may also be adjusted or removed.",
      ],
    },
    {
      id: 4,
      icon: "bx bx-check-circle",
      title: "4. Withdrawal After Completion",
      content: [
        "Once the required trading volume is fully completed, you can withdraw your invested balance, profits, and the converted bonus — all without restrictions.",
        "No bonus cancellation applies after conversion.",
        "Trading history and balance updates occur every night at 12:00 AM.",
      ],
    },
    {
      id: 5,
      icon: "bx bx-check-shield",
      title: "5. Trading Rules, Risk & General Terms",
      content: [
        "Volume must come from real market trades — hedging, arbitrage, scalping, and bonus abuse are strictly prohibited.",
        "Bonus may be removed in case of margin stop-out, account reset, or breach of terms.",
        "The broker reserves the right to modify or cancel the bonus program at any time without prior notice.",
        "Minimum deposit: $10 | Maximum deposit: $1,000 | Max bonus: $2,100.",
      ],
    },
  ];

  const toggleAccordion = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="mt-4 mb-5">
      {/* Section Header */}
      <div className="mb-4">
        <h5
          className="fw-bold mb-1"
          style={{ color: "var(--bs-emphasis-color)", fontSize: "1.2rem" }}
        >
          Terms &amp; Conditions
        </h5>
        <p className="mb-0 font-size-13" style={{ color: "var(--bs-secondary-color)" }}>
          View the full program details
        </p>
      </div>

      {/* Accordion List */}
      <div className="d-flex flex-column gap-2">
        {termsList.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={item.id}
              className="card border shadow-sm transition-all mb-1"
              style={{
                borderRadius: "var(--bs-border-radius-lg)",
                backgroundColor: "var(--bs-card-bg)",
                borderColor: isOpen
                  ? "var(--bs-primary-border-subtle)"
                  : "var(--bs-border-color)",
                overflow: "hidden",
                transition: "all 0.2s ease-in-out",
              }}
            >
              {/* Accordion Header */}
              <div
                className="card-header border-0 bg-transparent p-3 d-flex align-items-center justify-content-between cursor-pointer"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{
                      width: "34px",
                      height: "34px",
                      backgroundColor: isOpen
                        ? "var(--bs-primary-bg-subtle)"
                        : "var(--bs-tertiary-bg)",
                      color: isOpen
                        ? "var(--bs-primary)"
                        : "var(--bs-secondary-color)",
                      transition: "all 0.2s",
                    }}
                  >
                    <i className={`${item.icon} font-size-16`}></i>
                  </div>
                  <span
                    className="fw-bold font-size-14"
                    style={{
                      color: isOpen
                        ? "var(--bs-primary)"
                        : "var(--bs-emphasis-color)",
                      transition: "color 0.2s",
                    }}
                  >
                    {item.title}
                  </span>
                </div>

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: "26px",
                    height: "26px",
                    backgroundColor: isOpen
                      ? "var(--bs-primary-bg-subtle)"
                      : "var(--bs-tertiary-bg)",
                    color: isOpen
                      ? "var(--bs-primary)"
                      : "var(--bs-secondary-color)",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "all 0.2s ease",
                  }}
                >
                  <i className="bx bx-chevron-down font-size-16"></i>
                </div>
              </div>

              {/* Accordion Body */}
              {isOpen && (
                <div
                  className="card-body pt-0 px-3 pb-3"
                  style={{ borderTop: "1px solid var(--bs-border-color)" }}
                >
                  <ul
                    className="mb-0 ps-3 mt-2 font-size-13 d-flex flex-column gap-2"
                    style={{ lineHeight: "1.7" }}
                  >
                    {item.content.map((point, pIdx) => (
                      <li
                        key={pIdx}
                        style={{ color: "var(--bs-body-color)" }}
                      >
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
